module.exports = __webpack_public_path__ + "static/BusinessOfficeSupplies_Thumbnail-a10ff7c04568ba0a792266e9940f28bd.jpg";